import { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTRPCAPI, useTRPCMutation } from '../../../../trpc/trpc';
import { useApplyFreshUserToken } from '../../../team/useApplyFreshUserToken';

/**
 * Owner answer 5: a Free owner who never had a trial starts the 7-day trial from the credits
 * panel. The server answers a fresh session token with the trial limits; the hook applies it and
 * reads the credits again.
 */
export function useStartBrowseTrial() {
  const trpc = useTRPCAPI();
  const queryClient = useQueryClient();
  const applyToken = useApplyFreshUserToken();
  const mutation = useTRPCMutation(trpc.billing.startMusic24Trial.mutationOptions());
  const [failed, setFailed] = useState(false);

  const start = useCallback(async () => {
    setFailed(false);
    try {
      const { token } = await mutation.mutateAsync();
      await applyToken(token);
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: trpc.browse.usage.queryKey() }),
        queryClient.invalidateQueries({ queryKey: trpc.browse.search.queryKey() }),
      ]);
    } catch (error) {
      console.error('Browse trial start failed', error);
      setFailed(true);
    }
  }, [mutation, applyToken, queryClient, trpc.browse.usage, trpc.browse.search]);

  return { start, isPending: mutation.isPending, failed, started: mutation.isSuccess };
}
